// https://stackoverflow.com/a/9204568
export const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

// https://stackoverflow.com/a/40099504
export const capitalizeName = (name: string | undefined) =>
  name?.replace(/\b(\w)/g, s => s.toUpperCase());

export const normalizeValue = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // https://stackoverflow.com/a/37511463
    .trim()
    .toLowerCase();
